<template>
    <ul class="crumb-nav">
        <li :key="link.name" v-for="link in links">
            <a class="crumb-nav__item" @click="hook(link)">{{link.text}}</a>
        </li>
    </ul>
</template>

<script>
    import {RESET} from "../store/mutation-types";

    export default {
        props: [
            'links'
        ],
        name: "Breadcrumb",
        methods: {
            hook: function(link) {
                if (link.name === 'home') {
                    this.$store.commit(RESET);
                }
                this.$router.push({name: link.name, params: link.params});
            }
        }
    }
</script>

<style scoped lang="stylus">
    .crumb-nav
        margin 0
        padding 0
        list-style-type none
        li
            display inline-block
            margin-right 10px
        &__item
            width: 164px;
            height: 28px;
            font-family: "VWAGTheSansRegular",Arial,sans-serif;
            font-size: 18px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.56;
            letter-spacing: normal;
            color: #4c5356;
            position relative
            padding-left 15px
            cursor pointer
            &:before
                content: ''
                font-size 14px
                font-family: "VWAGTheSansRegular",Arial,sans-serif;
                margin:3px 6px
                position absolute
                top: 1px
                left: -22px
                background url("https://www.vwfsfleet.co.uk/app/themes/vwfs/img/icons/menu-arrow-down.svg") no-repeat #fff 50% 50%
                width 40px
                height 15px
                transform rotate(90deg)

</style>